// extracted by mini-css-extract-plugin
export default {"root":"BorrowerInfoTooltip_root__1xH8r","fields":"BorrowerInfoTooltip_fields__4Yg+k"};